import { EventEmitter, Injectable } from '@angular/core';
import { HttpRequest, HttpResponse, HttpErrorResponse, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Events } from 'ionic-angular';

import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import { EVT_SESSION_EXPIRED } from '../../constants';
import { JSONResponse } from '../../mediware-interfaces';

@Injectable()
export class MediwareHubInterceptor implements HttpInterceptor {

  constructor(public events: Events) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {    
       
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        let resp = event;      
        if (event instanceof HttpResponse) {
          
          /* posible fix para el back
          if (event.headers.get('content-type') != 'application/json'){
            console.log('content-type');
            console.log(event.headers.get('content-type'));
          }*/
          //si el http response no es un json debo crearlo para que todo no explote
          resp = event as HttpResponse<JSONResponse>;
          if (resp.body.error) {
            // si la respuesta JSON contiene el campo 'error'
            if (resp.body.error.message.includes('logearse')) {
              /* La sesión expiró o no es válida, genera evento.
               * En lugar de comparar el string del mensaje, lo mejor sería
               * setear el status de la respuesta como 403 Unauthorized */
              this.events.publish(EVT_SESSION_EXPIRED);
              console.log('session expired');
            } else {
              /* Workaround ya que todas las respuestas del server tienen
               * status = 200, inclusive si es un error. Si el campo error está
               * presente en la respuesta, lanzo un error para que sea manejado
               * más arriba en la app.
               */
              
              throw new HttpErrorResponse({ 
                error: resp.body,
                status: 400,
                statusText: resp.body.error.message,
              });
            }
          }
        } 
        return resp;
      })
    );
  }

}



// WEBPACK FOOTER //
// ./src/providers/mediware-hub-interceptor/mediware-hub-interceptor.ts